import React from 'react';
import { useNavigate } from 'react-router-dom';

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen flex justify-center items-center p-5"
      style={{ background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)" }}
    >
      <div className="bg-white p-10 rounded-xl shadow-lg w-full max-w-sm text-center">
        <div className="mb-7">
          <h1 className="text-2xl font-bold text-red-700 mb-2">Acesso Negado</h1>
          <p className="text-gray-500 text-base">Você não tem permissão para acessar esta página.</p>
        </div>
        <div>
          <p className="text-gray-500 text-sm mb-5">Esta área é restrita apenas para administradores do sistema.</p>
          <button
            className="px-6 py-3 rounded bg-[#4a90e2] text-white text-base font-medium cursor-pointer border-none transition-colors hover:bg-[#357abd]"
            onClick={() => navigate(-1)}
          >
            Voltar
          </button>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;